export class navMenu {
  constructor(difference) {
    this.width = 320
    this.height = 36
    this.top = 20
    this.left = 20
    this.innerElement = "cxNavMenu"
    this.mode = "horizontal" //horizontal / vertical
    this.menuTrigger = "hover"
    this.collapse = false //是否水平折叠收起菜单（仅在 mode 为 vertical 时可用）
    this.bgColor = "#fff"
    this.bgIsThemeColor = false
    this.fontFamily = "sans-serif"
    this.textIsThemeColor = false
    this.fontSize = 14
    this.fontWeight = "400"
    this.color = "rgba(0,0,0,0.8)"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.textDecoration = "none"
    this.textIndent = 0
    this.lineHeight = 36
    this.lineHeightType = "px"
    this.value = ""
    this.opacity = 100
    this.background = []
    this.topNavTextLimit = true // 一级菜单字数限制
    this.topNavTextLimitCount = 4
    // 阴影
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]

    this.widthAuto = true // 宽度 固定和自适应
    this.navWidth = 106
    this.heightAuto = false // 高度 固定和自适应
    this.navHeight = 60
    this.margin = 10
    this.selectOptions = [
      {
        label: "菜单1",
        value: "",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          }
        ]
      },
      {
        label: "菜单2",
        value: "http://www.baidu.com",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/"
          }
        ]
      },
      {
        label: "菜单3",
        value: "http://www.baidu.com",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/"
          }
        ]
      },
      {
        label: "菜单4",
        value: ""
      }
    ]
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderTopRightRadius = 0
    this.borderTopLeftRadius = 0

    this.showBorder = false
    this.borderWidth = 0
    this.borderColor = "#3D82F2"
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false

    this.topNavBackground = []
    this.topNavBgColor = "#fff"
    this.topNavBgColorIsThemeColor = false
    this.topNavBorderWidth = 0
    this.topNavBorderColor = "#3D82F2"
    this.topNavBorderStyle = "solid" // solid, dashed, dotted
    this.topNavBorderIsThemeColor = false

    this.topNavBoxShadowColor = ["rgba(255,255,255,1)"]
    this.topNavBoxShadowH = [0]
    this.topNavBoxShadowV = [0]
    this.topNavBoxShadowBlur = [0]
    this.topNavBoxShadowSpread = [0]

    this.topNavBorderTypeFlag = 2
    this.topNavBorderRadius = 0
    this.topNavBorderBottomLeftRadius = 0
    this.topNavBorderBottomRightRadius = 0
    this.topNavBorderTopRightRadius = 0
    this.topNavBorderTopLeftRadius = 0
    this.topNavPadding = 0
    this.topNavPaddingTop = 0
    this.topNavPaddingRight = 20
    this.topNavPaddingLeft = 20
    this.topNavPaddingBottom = 0
    this.topNavPaddingTypeFlag = 2

    this.iconPosition = "right" // left,right
    this.iconSrc = "5CB4CFFC9CE56FF2"
    this.iconType = "icon" // img,icon 图片和字体图标
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "rgba(0,0,0,0.4)"

    this.selectFontFamily = "sans-serif"
    this.selectFontSize = 14
    this.selectFontWeight = "400"
    this.selectFontColor = "rgba(0,0,0,1)"

    this.selectBgColor = "#fff"
    this.selectBgIsThemeColor = false
    this.selectBorderColor = "#3D82F2"
    this.selectBorderWidth = 0 //下拉框边框宽度
    this.selectBorderStyle = "solid" // solid, dashed, dotted 下拉框边框风格
    this.selectBorderIsThemeColor = false // 下拉框边框颜色

    this.liWidthAuto = false //下拉列表和下拉框同尺寸  宽度
    this.liIsSameSizeHeight = false //下拉列表和下拉框同尺寸   高度
    this.liHeight = 40 // 下拉列表项高度
    this.liWidth = 160 // 下拉列表项高度
    this.liBorderWidth = 0
    this.liBorderColor = "#3D82F2"
    this.liBorderStyle = "solid" // solid, dashed, dotted
    this.liBorderIsThemeColor = false
    this.liFontFamily = "sans-serif"
    this.liFontSize = 14
    this.liFontWeight = "400"
    this.liFontColor = "rgba(0,0,0,0.8)"
    this.liIsThemeColor = false
    this.liLetterSpacing = 0
    this.liFontStyle = "normal"
    this.liTextAlign = "left"
    this.liWritingMode = "horizontal-tb"
    this.liTextDecoration = "none"
    this.liTextIndent = 0
    this.liLineHeight = 36

    this.selectBoxShadowColor = ["#E9E9E9", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.12)"] // 下拉列表的阴影
    this.selectBoxShadowH = [0, 0, 0]
    this.selectBoxShadowV = [0, 6, 8]
    this.selectBoxShadowBlur = [0, 16, 20]
    this.selectBoxShadowSpread = [1, 0, 0]

    this.activeFontFamily = "sans-serif"
    this.activeFontSize = 14
    this.activeFontWeight = "400"
    this.activeFontColor = "rgba(0, 0, 0, 0.8)"
    this.activeTextIsThemeColor = true
    this.activeLetterSpacing = 0
    this.activeFontStyle = "normal"
    this.activeTextAlign = "left"
    this.activeWritingMode = "horizontal-tb"
    this.activeTextDecoration = "none"
    this.activeTextIndent = 0
    this.activeLineHeight = 36
    this.activeBgColor = "#F0F2F7"
    this.activeBgIsThemeColor = false
    this.activeBorderWidth = 0
    this.activeBorderColor = "#3D82F2"
    this.activeBorderStyle = "solid" // solid, dashed, dotted
    this.activeBorderIsThemeColor = false

    this.hoverIsSameActive = true
    this.hoverFontFamily = "sans-serif"
    this.hoverFontSize = 14
    this.hoverFontWeight = "400"
    this.hoverFontColor = "#3D82F2"
    this.hoverTextIsThemeColor = false
    this.hoverLetterSpacing = 0
    this.hoverLineHeight = 36
    this.hoverFontStyle = "normal"
    this.hoverTextAlign = "left"
    this.hoverWritingMode = "horizontal-tb"
    this.hoverTextDecoration = "none"
    this.hoverTextIndent = 0
    this.hoverBgColor = "#F0F2F7"
    this.hoverBgIsThemeColor = false
    this.hoverBorderWidth = 0
    this.hoverBorderColor = "#3D82F2"
    this.hoverBorderStyle = "solid" // solid, dashed, dotted
    this.hoverBorderIsThemeColor = false

    this.ulBgIsThemeColor = false //下拉块的背景颜色
    this.ulBgColor = "#fff"

    this.liHoverFontFamily = "sans-serif"
    this.liHoverFontSize = 14
    this.liHoverFontWeight = "400"
    this.liHoverFontColor = "#3D82F2"
    this.liHoverTextIsThemeColor = true
    this.liHoverLetterSpacing = 0
    this.liHoverFontStyle = "normal"
    this.liHoverTextAlign = "left"
    this.liHoverWritingMode = "horizontal-tb"
    this.liHoverTextDecoration = "none"
    this.liHoverTextIndent = 0
    this.liHoverLineHeight = 36
    this.liHoverBgColor = "#F0F2F7"
    this.liHoverBgIsThemeColor = false
    this.liHoverBorderWidth = 0
    this.liHoverBorderColor = "#F0F2F7"
    this.liHoverBorderStyle = "solid" // solid, dashed, dotted
    this.liHoverBorderIsThemeColor = false

    this.liActiveFontFamily = "sans-serif"
    this.liActiveFontSize = 14
    this.liActiveFontWeight = "400"
    this.liActiveFontColor = "#3D82F2"
    this.liActiveTextIsThemeColor = true
    this.liActiveLetterSpacing = 0
    this.liActiveFontStyle = "normal"
    this.liActiveTextAlign = "left"
    this.liActiveWritingMode = "horizontal-tb"
    this.liActiveTextDecoration = "none"
    this.liActiveTextIndent = 0
    this.liActiveLineHeight = 36
    this.liActiveBgColor = "#F0F2F7"
    this.liActiveBgIsThemeColor = false
    this.liActiveBorderWidth = 0
    this.liActiveBorderColor = "#F0F2F7"
    this.liActiveBorderStyle = "solid" // solid, dashed, dotted
    this.liActiveBorderIsThemeColor = false

    this.showTopNavIcon = true
    this.verticalAlign = "top"
    this.showTopNavBorder = false
    this.topNavOpacity = 100
    this.topNavRotate = 0
    this.showLiBorder = false
    this.liVerticalAlign = "top"
    this.liTextLimitCount = 4
    this.liTextLimit = false
    this.showTopNavActiveBorder = false
    this.activeVerticalAlign = "top"
    this.topNavActiveTextLimitCount = 4
    this.topNavActiveTextLimit = true
    this.topNavActiveBorderTypeFlag = 2
    this.topNavActiveBorderRadius = 0
    this.topNavActiveBorderTopLeftRadius = 0
    this.topNavActiveBorderTopRightRadius = 0
    this.topNavActiveBorderBottomRightRadius = 0
    this.topNavActiveBorderBottomLeftRadius = 0
    this.showTopNavHoverBorder = false
    this.hoverVerticalAlign = "top"
    this.hoverTextLimitCount = 4
    this.hoverTextLimit = true
    this.topNavHoverBorderTypeFlag = 2
    this.topNavHoverBorderRadius = 0
    this.topNavHoverBorderTopLeftRadius = 0
    this.topNavHoverBorderTopRightRadius = 0
    this.topNavHoverBorderBottomRightRadius = 0
    this.topNavHoverBorderBottomLeftRadius = 0
    this.showLiHoverBorder = false
    this.liHoverBorderTypeFlag = 2
    this.liHoverBorderRadius = 0
    this.liHoverBorderTopLeftRadius = 0
    this.liHoverBorderTopRightRadius = 0
    this.liHoverBorderBottomRightRadius = 0
    this.liHoverBorderBottomLeftRadius = 0
    this.liHoverVerticalAlign = "top"
    this.liHoverTextLimitCount = 4
    this.liHoverTextLimit = true
    this.liIconPosition = "right"
    this.showLiIcon = true
    this.liIconSrc = "5CB4CFFC9CE56FF2"
    this.liIconType = "icon"
    this.liIconWidth = 14
    this.liIconMargin = 10
    this.liIconColorIsThemeColor = false
    this.liIconColor = "rgba(0,0,0,0.4)"
    this.liResInfo = {}
    this.liBorderTypeFlag = 2
    this.liBorderRadius = 0
    this.liBorderTopLeftRadius = 0
    this.liBorderTopRightRadius = 0
    this.liBorderBottomRightRadius = 0
    this.liBorderBottomLeftRadius = 0
    this.liPaddingTypeFlag = 2
    this.liPadding = 0
    this.liPaddingTop = 0
    this.liPaddingRight = 10
    this.liPaddingLeft = 10
    this.liPaddingBottom = 0
    this.liOpacity = 100
    this.liRotate = 0
    this.liMargin = 0
    this.ulBackground = []
    // 列表
    this.ulWidthAuto = true
    this.ulHeightAuto = true
    this.ulWidth = 160  // 下拉列表框高度
    this.ulHeight = 160 // 下拉列表框高度
    this.showUlBorder = false
    this.ulBorderWidth = 0
    this.ulBorderColor = "#3D82F2"
    this.ulBorderStyle = "solid" // solid, dashed, dotted
    this.ulBorderIsThemeColor = false
    this.ulBorderTypeFlag = 2
    this.ulBorderRadius = 0
    this.ulBorderTopLeftRadius = 0
    this.ulBorderTopRightRadius = 0
    this.ulBorderBottomRightRadius = 0
    this.ulBorderBottomLeftRadius = 0
    this.ulBoxShadowColor = []
    this.ulBoxShadowH = [0]
    this.ulBoxShadowV = [0]
    this.ulBoxShadowBlur = [0]
    this.ulBoxShadowSpread = [0]
    this.ulPaddingTypeFlag = 2
    this.ulPadding = 0
    this.ulPaddingTop = 0
    this.ulPaddingRight = 0
    this.ulPaddingLeft = 0
    this.ulPaddingBottom = 0
    this.ulOpacity = 100
    this.ulRotate = 0
    this.navMargin = 0
    this.subMenuConfig = []
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.openBlankPage = true
    this.liShowMaxWidth = false
    this.liShowMinWidth = false
    this.liMaxWidthVal = 0
    this.liMinWidthVal = 0
    this.ulAlignmentType = "left"
    this.ulMarginTop = 0
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
